export default class ObjectUtil {
    public static isFunction(func: () => void): boolean {
        return func && {}.toString.call(func) === '[object Function]';
    }
}
